module.exports = __webpack_public_path__ + "images/fontawesome-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./~/vue-blu/dist/img/fontawesome-webfont.svg
// module id = 953
// module chunks = 2